/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | canada_post_regular_parcel | Regular Parcel|
 * | canada_post_expedited_parcel | Expedited Parcel|
 * | canada_post_priority | Priority|
 * | canada_post_xpresspost | Xpresspost|
 * | canada_post_xpresspost_international | Xpresspost International|
 * | canada_post_xpresspost_usa | Xpresspost USA|
 * | canada_post_expedited_parcel_usa | Expedited Parcel USA|
 * | canada_post_tracked_packet_usa | Tracked Packet USA|
 * | canada_post_small_packet_usa_air | Small Packet USA Air|
 * | canada_post_tracked_packet_international | Tracked Packet International|
 * | canada_post_small_packet_international_air | Small Package International Air|
 * | canada_post_small_packet_international_surface  | Small Packet International Surface
 * | canada_post_international_parcel_surface  | International Parcel Surface
 * | canada_post_international_parcel_air  | International Parcel Air
 */
export const ServiceLevelCanadaPostEnum = {
  CanadaPostRegularParcel: "canada_post_regular_parcel",
  CanadaPostExpeditedParcel: "canada_post_expedited_parcel",
  CanadaPostPriority: "canada_post_priority",
  CanadaPostXpresspost: "canada_post_xpresspost",
  CanadaPostXpresspostInternational: "canada_post_xpresspost_international",
  CanadaPostXpresspostUsa: "canada_post_xpresspost_usa",
  CanadaPostExpeditedParcelUsa: "canada_post_expedited_parcel_usa",
  CanadaPostTrackedPacketUsa: "canada_post_tracked_packet_usa",
  CanadaPostSmallPacketUsaAir: "canada_post_small_packet_usa_air",
  CanadaPostTrackedPacketInternational:
    "canada_post_tracked_packet_international",
  CanadaPostSmallPacketInternationalAir:
    "canada_post_small_packet_international_air",
  CanadaPostSmallPacketInternationalSurface:
    "canada_post_small_packet_international_surface",
  CanadaPostInternationalParcelSurface:
    "canada_post_international_parcel_surface",
  CanadaPostInternationalParcelAir: "canada_post_international_parcel_air",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | canada_post_regular_parcel | Regular Parcel|
 * | canada_post_expedited_parcel | Expedited Parcel|
 * | canada_post_priority | Priority|
 * | canada_post_xpresspost | Xpresspost|
 * | canada_post_xpresspost_international | Xpresspost International|
 * | canada_post_xpresspost_usa | Xpresspost USA|
 * | canada_post_expedited_parcel_usa | Expedited Parcel USA|
 * | canada_post_tracked_packet_usa | Tracked Packet USA|
 * | canada_post_small_packet_usa_air | Small Packet USA Air|
 * | canada_post_tracked_packet_international | Tracked Packet International|
 * | canada_post_small_packet_international_air | Small Package International Air|
 * | canada_post_small_packet_international_surface  | Small Packet International Surface
 * | canada_post_international_parcel_surface  | International Parcel Surface
 * | canada_post_international_parcel_air  | International Parcel Air
 */
export type ServiceLevelCanadaPostEnum = ClosedEnum<
  typeof ServiceLevelCanadaPostEnum
>;

/** @internal */
export const ServiceLevelCanadaPostEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelCanadaPostEnum
> = z.nativeEnum(ServiceLevelCanadaPostEnum);

/** @internal */
export const ServiceLevelCanadaPostEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelCanadaPostEnum
> = ServiceLevelCanadaPostEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelCanadaPostEnum$ {
  /** @deprecated use `ServiceLevelCanadaPostEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelCanadaPostEnum$inboundSchema;
  /** @deprecated use `ServiceLevelCanadaPostEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelCanadaPostEnum$outboundSchema;
}
